import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=beb0e02c&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=ts"
export * from "./Copyright.vue?vue&type=script&lang=ts"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=beb0e02c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb0e02c",
  null
  
)

export default component.exports